import { IconButton, Dialog, DialogTitle, DialogActions, Tooltip, Button, Snackbar, SnackbarContent } from '@material-ui/core';
import * as React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import './ShareMonthlyEvolution.scss'
import { useState } from 'react';
import Rest from 'src/services/Rest';
import ExportInProgress from 'src/component/export-in-progress/ExportInProgress';

  interface IDialogShareMonthlyEvolutionProps {
    getFilter: (pagination: boolean) => void;   
  }

  const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
  };
  
  export default function DialogShareMonthlyEvolution(props: IDialogShareMonthlyEvolutionProps) { 
    
    const { getFilter } = props;
    const [open, setOpen] =useState<boolean>(false)
    const [processando, setProcessando] = useState<boolean>(false)
    const [alert, setStateAlert] = useState({
        message: "",
        open: false,
        type: "",
      });

    const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
    };

    const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
    };

    const requestExport = (tipo: any) => {
        let endPoint = `share-month-evolution/export/${tipo}/`
        const api = getFilter(false) as any;
        
        if (api) {
            endPoint += api
        }

    Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
         setOpen(false)
         openAlert('O relatório está sendo preparado para download', 'sucess');
         setProcessando(true)
      });
    }
  
    return (
        <div style={{marginRight: '30px'}}>
          {!processando && 
            <IconButton
              color="primary"
              className="download-button"
              onClick={()=>setOpen(true)}
            >
              <Tooltip title="Exportar">
                <GetAppIcon/>
              </Tooltip>
            </IconButton>
          }
          <ExportInProgress 
            tipos={['PUBLISHER_EVOLUTION_MONTH_DATA_GRUPO', 'PUBLISHER_EVOLUTION_MONTH_DATA_LOJA']}
            visible={processando}
            handleState={(valor) => setProcessando(valor)}/>

        <Snackbar
            anchorOrigin={{
                horizontal: "center",
                vertical: "center",
            }}
            open={alert.open}
            autoHideDuration={4000}
            onClose={closeAlert}
            >
            <SnackbarContent
                message={alert.message}
                style={styles[alert.type]}
            />
        </Snackbar>

        <Dialog
            open={open}
            onClose={()=> setOpen(false)}
            aria-labelledby="economic-group-dialog-title"
            aria-describedby="alereconomic-group-dialog-description"
            className="filter-dialog"
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
        >
            <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                {"Exportação do Relatório Evolução Share Mensal"}
            </DialogTitle>
            <DialogActions style={{justifyContent: 'center'}}>
                <Button onClick={()=> setOpen(false)} color="secondary">
                    Cancelar
                </Button>
                <Button onClick={()=> requestExport('POR_GRUPO')} color="primary" autoFocus={true}>
                 Grupo Economico
                </Button>
                <Button onClick={()=> requestExport('POR_LOJA')} color="primary" autoFocus={true}>
                 Loja
                </Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
  
  
  


// WEBPACK FOOTER //
// ./src/component/publisher/sale/share-mothly-evolution/DialogExportMonthlyEvolution.tsx